
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import objectIsPrototypeOf from './object-is-prototype-of.js';

var isPrototypeOf = objectIsPrototypeOf;

var $TypeError = TypeError;

var anInstance = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw new $TypeError('Incorrect invocation');
};

export { anInstance as default };
//# sourceMappingURL=an-instance.js.map
